import { createAction } from '@reduxjs/toolkit';
export const FETCH_ANALYTIC_DOMAIN_SETTINGS = 'FETCH_ANALYTIC_DOMAIN_SETTINGS';
export const fetchAnalyticDomainSettingsAction = createAction(FETCH_ANALYTIC_DOMAIN_SETTINGS);